module.exports = __webpack_public_path__ + "media/lineas/4-e84c3331.png";